import { render, staticRenderFns } from "./GeralTreinamentoProfessorComponent.vue?vue&type=template&id=8439aba2&scoped=true&"
import script from "./GeralTreinamentoProfessorComponent.vue?vue&type=script&lang=js&"
export * from "./GeralTreinamentoProfessorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8439aba2",
  null
  
)

export default component.exports